import React, { useState } from "react";
import "../../CSS/Global.css";
import { useSidebar } from "../../SidebarContext";
import Header from "../Header";
import Sidebar from "../SideBar";
import * as XLSX from 'xlsx';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CustomerImport = () => {
    const { isSidebarOpen } = useSidebar();
    const [currentStep, setCurrentStep] = useState(1);
    const [previewData, setPreviewData] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [skippedRecords, setSkippedRecords] = useState([]);
    const [validInvoices, setValidInvoices] = useState([]);
    const [failedInvoices, setFailedInvoices] = useState([]);
    const [unmappedFields, setUnmappedFields] = useState([]);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [fieldMappings, setFieldMappings] = useState({});
    const [excelHeaders, setExcelHeaders] = useState([]);
    const [rawExcelData, setRawExcelData] = useState([]);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const navigate = useNavigate();
    const url = process.env.REACT_APP_LINK
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));

    const [importStats, setImportStats] = useState({
        count: 0,
        skipped: 0,
        unmapped: 0,
    });

    // const handleNext = () => {
    //     if (currentStep === 2) checkUnmappedFields(); // Check before going to step 3
    //     if (currentStep < 3) setCurrentStep(currentStep + 1);
    // };
    const handleNext = () => {
        if (currentStep === 2) {
            checkUnmappedFields(); // Set importStats.unmapped

            const requiredFields = ["customerName", "phone1"];
            const mappedData = rawExcelData.map((row) => {
                const obj = {};
                fields.forEach((fieldKey) => {
                    const mappedHeader = fieldMappings[fieldKey];
                    if (!mappedHeader || mappedHeader === "none") return;

                    const value = row[mappedHeader] || "";
                    if (fieldKey.includes(".")) {
                        const [parent, child] = fieldKey.split(".");
                        if (!obj[parent]) obj[parent] = {};
                        obj[parent][child] = value;
                    } else {
                        obj[fieldKey] = value;
                    }
                });
                obj.user_id = isLoggedIn?.user_id || "";
                return obj;
            });

            // ✅ Validate mapped fields
            const valid = mappedData.filter((cust) =>
                requiredFields.every((f) => {
                    if (f.includes(".")) {
                        const [p, c] = f.split(".");
                        return cust[p] && cust[p][c];
                    }
                    return cust[f];
                })
            );

            setValidInvoices(valid);

            setImportStats(prev => ({
                ...prev,
                count: valid.length,
                skipped: mappedData.length - valid.length
            }));
        }

        if (currentStep < 3) setCurrentStep(currentStep + 1);
    };



    const handleBack = () => {
        if (currentStep > 1) setCurrentStep(currentStep - 1);
    };

    const convertExcelDate = (serial) => {
        const baseDate = new Date(1899, 11, 30);
        const corrected = new Date(baseDate.getTime() + (serial + 1) * 86400000);
        return corrected.toISOString().split("T")[0];
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        // if (!file) {
        //     setUploadSuccess(false); // clear previous success
        //     return;
        // };

        // setUploadedFileName(file.name);
        // setFileName(file.name); // ✅ Fix: Show selected file name in Step 2
        
        if (!file) {
            setUploadSuccess(false);
            return;
        }

        // ✅ Check file extension
        const allowedExtensions = ["csv", "xlsx", "xls"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file format. Please upload a CSV, XLSX, or XLS file.", {
                position: "top-center",
                autoClose: 3000
            });
            e.target.value = ""; // Clear input
            return;
        }


        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
            const headers = Object.keys(data[0] || {});
            setExcelHeaders(headers);
            setRawExcelData(data); // new state

            // Auto-map headers to field mappings
            const autoMapped = {};
            fields.forEach((field) => {
                const label = fieldLabels[field];
                const match = headers.find(h => h.trim().toLowerCase() === label.trim().toLowerCase());
                if (match) {
                    autoMapped[field] = match;
                }
            });
            setFieldMappings(autoMapped);


            const parsed = [];
            const reasonSet = new Set();

            const requiredFields = ["Customer Name", "Email", "Phone 1"];

            data.forEach((row, index) => {
                let hasMissing = false;

                requiredFields.forEach((field) => {
                    if (!(field in row) || row[field] === "") {
                        reasonSet.add(`Row ${index + 2}: Missing or empty "${field}"`);
                        hasMissing = true;
                    }
                });

                parsed.push({
                    customerName: row["Customer Name"] || "",
                    companyName: row["Company Name"] || "",
                    displayName: row["Display Name"] || "",
                    email: row["Email"] || "",
                    phone1: row["Phone 1"] || "",
                    phone2: row["Phone 2"] || "",
                    gstNumber: row["GST Number"] || "",
                    placeOfSupply: row["Place of Supply"] || "",
                    pan: row["PAN"] || "",
                    currency: row["Currency"] || "INR",
                    remarks: row["Remarks"] || "",
                    website_url: row["Website URL"] || "",
                    department: row["Department"] || "",
                    designation: row["Designation"] || "",
                    twitter: row["Twitter"] || "",
                    skype: row["Skype"] || "",
                    facebook: row["Facebook"] || "",
                    billingAddress: {
                        attention: row["Billing Attention"] || "",
                        country: row["Billing Country"] || "",
                        address: row["Billing Address"] || "",
                        city: row["Billing City"] || "",
                        state: row["Billing State"] || "",
                        pincode: row["Billing Pincode"] || "",
                        number: row["Billing Number"] || ""
                    },
                    shippingAddress: {
                        attention: row["Shipping Attention"] || "",
                        country: row["Shipping Country"] || "",
                        address: row["Shipping Address"] || "",
                        city: row["Shipping City"] || "",
                        state: row["Shipping State"] || "",
                        pincode: row["Shipping Pincode"] || "",
                        number: row["Shipping Number"] || ""
                    }
                });
            });

            setPreviewData(parsed);
            setExcelData(parsed); // ✅ Save parsed data to send to backend

            const valid = parsed.filter((_, i) => {
                const original = data[i];
                return requiredFields.every(f => f in original && original[f]);
            });
            setImportStats(prev => ({
                ...prev,
                count: valid.length
            }));

            setValidInvoices(valid);
            setSkippedRecords([...reasonSet]);

            const unmappedOnly = Array.from(reasonSet).filter(reason =>
                reason.includes("is not a number")
            );
            setUnmappedFields(unmappedOnly);

            const skippedOnly = Array.from(reasonSet).filter(reason =>
                !reason.includes("is not a number")
            );
            setSkippedRecords(skippedOnly);
        };
        setUploadSuccess(true);
        reader.readAsBinaryString(file);
    };


    const handleImport = async () => {
        try {
            const remappedData = rawExcelData.map((row) => {
                const mappedRow = {};

                fields.forEach((fieldKey) => {
                    const mappedHeader = fieldMappings[fieldKey]; // e.g. Display Name
                    if (!mappedHeader || mappedHeader === "none") return;

                    if (fieldKey.includes(".")) {
                        const [parent, child] = fieldKey.split(".");
                        if (!mappedRow[parent]) mappedRow[parent] = {};
                        mappedRow[parent][child] = row[mappedHeader] || "";
                    } else {
                        mappedRow[fieldKey] = row[mappedHeader] || "";
                    }
                });

                mappedRow.user_id = isLoggedIn?.user_id || "";

                return mappedRow;
            });

            const res = await fetch(`${url}/api/customer/import-bulk`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ customers: remappedData })
            });

            const data = await res.json();
            if (res.ok) {
                setImportStats({
                    count: data.count || 0,
                    skipped: data.skipped || 0,
                    unmapped: data.unmapped || 0,
                });
                toast.success(data.message + " Total: " + data.count, {
                    position: "top-center",
                    autoClose: 2000
                });
                navigate("/customer")

            }
            // alert(data.message + " Total: " + data.count);
        } catch (err) {
            console.error(err);
            alert("Import failed");
        }
    };





    const checkUnmappedFields = () => {
        const total = fields.length;
        const mappedCount = Object.values(fieldMappings).filter(val => val && val !== "none").length;
        const unmapped = total - mappedCount;

        setImportStats(prev => ({ ...prev, unmapped }));
    };


    const options = [
        { value: "Customer Name", label: "Customer Name" },
        { value: "Company Name", label: "Company Name" },
        { value: "Display Name", label: "Display Name" },
        { value: "Email", label: "Email" },
        { value: "Phone 1", label: "Phone 1" },
        { value: "Phone 2", label: "Phone 2" },
        { value: "GST Number", label: "GST Number" },
        { value: "Place of Supply", label: "Place of Supply" },
        { value: "PAN", label: "PAN" },
        { value: "Currency", label: "Currency" },
        { value: "Remarks", label: "Remarks" },
        { value: "Website URL", label: "Website URL" },
        { value: "Department", label: "Department" },
        { value: "Designation", label: "Designation" },
        { value: "Twitter", label: "Twitter" },
        { value: "Skype", label: "Skype" },
        { value: "Facebook", label: "Facebook" },
        { value: "Billing Attention", label: "Billing Attention" },
        { value: "Billing Country", label: "Billing Country" },
        { value: "Billing Address", label: "Billing Address" },
        { value: "Billing City", label: "Billing City" },
        { value: "Billing State", label: "Billing State" },
        { value: "Billing Pincode", label: "Billing Pincode" },
        { value: "Billing Number", label: "Billing Number" },
        { value: "Shipping Attention", label: "Shipping Attention" },
        { value: "Shipping Country", label: "Shipping Country" },
        { value: "Shipping Address", label: "Shipping Address" },
        { value: "Shipping City", label: "Shipping City" },
        { value: "Shipping State", label: "Shipping State" },
        { value: "Shipping Pincode", label: "Shipping Pincode" },
        { value: "Shipping Number", label: "Shipping Number" }
    ];


    const fields = [
        "customerName",
        "companyName",
        "displayName",
        "email",
        "phone1",
        "phone2",
        "gstNumber",
        "placeOfSupply",
        "pan",
        "currency",
        "remarks",
        "website_url",
        "department",
        "designation",
        "twitter",
        "skype",
        "facebook",
        "billingAddress.attention",
        "billingAddress.country",
        "billingAddress.address",
        "billingAddress.city",
        "billingAddress.state",
        "billingAddress.pincode",
        "billingAddress.number",
        "shippingAddress.attention",
        "shippingAddress.country",
        "shippingAddress.address",
        "shippingAddress.city",
        "shippingAddress.state",
        "shippingAddress.pincode",
        "shippingAddress.number"
    ];


    const fieldLabels = {
        customerName: "Customer Name",
        companyName: "Company Name",
        displayName: "Display Name",
        email: "Email",
        phone1: "Phone 1",
        phone2: "Phone 2",
        gstNumber: "GST Number",
        placeOfSupply: "Place of Supply",
        pan: "PAN",
        currency: "Currency",
        remarks: "Remarks",
        website_url: "Website URL",
        department: "Department",
        designation: "Designation",
        twitter: "Twitter",
        skype: "Skype",
        facebook: "Facebook",
        "billingAddress.attention": "Billing Attention",
        "billingAddress.country": "Billing Country",
        "billingAddress.address": "Billing Address",
        "billingAddress.city": "Billing City",
        "billingAddress.state": "Billing State",
        "billingAddress.pincode": "Billing Pincode",
        "billingAddress.number": "Billing Number",
        "shippingAddress.attention": "Shipping Attention",
        "shippingAddress.country": "Shipping Country",
        "shippingAddress.address": "Shipping Address",
        "shippingAddress.city": "Shipping City",
        "shippingAddress.state": "Shipping State",
        "shippingAddress.pincode": "Shipping Pincode",
        "shippingAddress.number": "Shipping Number"
    };




    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h2 className="customer-import">Customer - select file</h2>

                {/* Step Indicators */}
                <div className="import-step">
                    {[1, 2, 3].map(step => (
                        <div
                            key={step}
                            className={`import-step__item ${currentStep === step ? "active" : currentStep > step ? "past" : "upcoming"}`}
                        >
                            {step}
                        </div>
                    ))}
                </div>

                {/* Step 1: Upload */}
                {currentStep === 1 && (
                    <div className="customer-import-card">
                        <div className="import-icon">
                            <i className="fa-solid fa-file-arrow-down"></i>
                        </div>
                        <p className="scan-drop">Drag and drop file to import</p>
                        <div className="upload-file">
                            <label htmlFor="file" className="upload-border">
                                <i className="fa-solid fa-file-arrow-down"></i> Import file
                                <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    className="file-input"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    onChange={handleFileUpload}
                                />
                            </label>
                        </div>
                        {uploadSuccess && (
                            <p className="upload-success-message">
                                ✅ File <strong>{fileName}</strong> uploaded successfully!
                            </p>
                        )}

                        <p className="file-type">
                            Maximum File Size: 25 MB • File Format: CSV, TSV, or XLS
                        </p>
                        <p className="example-file">
                            Download a sample csv or xls file and compare it to your import file to ensure compatibility.
                        </p>
                    </div>
                )}

                {/* Step 2: Mapping */}
                {currentStep === 2 && (
                    <div className="customer-import-card">
                        <p className="selected-file">
                            Your Selected File: {fileName}
                        </p>
                        <div className="import-mapping">
                            <div className="import-mapping-label mapping-label-head">
                                100billion OMS field
                            </div>
                            <div className="import-mapping-select mapping-selecy-head">
                                Import file field
                            </div>
                        </div>
                        {fields.map((field, index) => (
                            <div className="import-mapping" key={index}>
                                <div className="import-mapping-label">{fieldLabels[field]}:</div>

                                <div className="import-mapping-select">
                                    <select
                                        value={fieldMappings[field] || "none"}
                                        onChange={(e) => {
                                            const newMappings = { ...fieldMappings, [field]: e.target.value };
                                            setFieldMappings(newMappings);
                                        }}
                                    >
                                        <option value="none">-- Select Field --</option>
                                        {excelHeaders.map((header, idx) => (
                                            <option key={idx} value={header}>
                                                {header}
                                            </option>
                                        ))}
                                    </select>


                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Step 3: Summary */}
                {currentStep === 3 && (
                    <div className="customer-import-card">
                        <p className="import-success">
                            Customers ready to import: {importStats.count}
                        </p>
                        <p className="import-error">
                            Skipped Records: {importStats.skipped}
                        </p>
                        <p className="import-error">
                            Unmapped Fields: {importStats.unmapped}
                        </p>
                    </div>
                )}

                {/* Buttons */}
                <div className="import-buttons">
                    {currentStep > 1 && (
                        <button className="import-back" onClick={handleBack}>
                            Back
                        </button>
                    )}
                    {currentStep === 3 ? (
                        <button className="import-button" onClick={handleImport}>
                            Import
                        </button>
                    ) : (
                        <button className="import-next" onClick={handleNext}>
                            Next
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default CustomerImport;
